// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: 'AIzaSyBJoKBxZQCrJ9RDL6AhKDPlfYimNEi1PJA',
    authDomain: 'staging.ashgridx.ashipaelectric.com',
    projectId: 'ashgridx-staging',
    storageBucket: 'ashgridx-staging.firebasestorage.app',
    messagingSenderId: '945401996142',
    appId: '1:945401996142:web:9e76db6be514bb383c577f',
    measurementId: 'G-BMM4B52RML',
  },
  production: false,
  local: false,
  websiteUrl: 'https://staging.ashgridx.ashipaelectric.com',
  consoleUrl: 'https://staging.console.ashgridx.ashipaelectric.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
